import { mobileSettingsApi } from 'services/api/mobile-settings/queries';
import { FeatureName } from 'types/entities/MobileSettings';

export default function useFlag(feature: FeatureName) {
  const { data, isLoading, isSuccess } =
    mobileSettingsApi.useGetMobileSettingsQuery();
  const disabledFeatureFlags = data?.disabledFeatureFlags;
  return isSuccess && !isLoading && !disabledFeatureFlags?.includes(feature);
}
